import { render } from "./CourtSwitch.vue?vue&type=template&id=07534279"
import script from "./CourtSwitch.vue?vue&type=script&lang=js"
export * from "./CourtSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__